import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import confetti from 'canvas-confetti';
import { Subscription } from 'rxjs';
import { MyDiscountService } from 'src/app/shared/services/my-discount.service';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { DiscountProduct } from 'src/app/shared/models/discount-product';
import { GoogleCustomer } from 'src/app/shared/models/googlecustomer';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { SelectedRewardProductDto } from 'src/app/shared/models/selected-reward-product-dto';
import { ToastService } from 'src/app/shared/services/toastr.service';
import { WebSocketService } from 'src/app/common/WebSocketService';

@Component({
  selector: 'app-my-discount',
  templateUrl: './my-discount.component.html',
  styleUrls: ['./my-discount.component.scss']
})
export class MyDiscountComponent implements OnInit {

  productList: any[] = [];
  activeTab: string = 'home';
  activeSort: string = '';
  homeCount: number = 0;
  redeemedCount: number = 0;
  showLuckModal = false;
  wonDiscount = 0;
  qrData = '';
  selectedRewardType: 'money' | 'product' | null = null;
  // selectedRewardProduct: RewardOption | null = null;
  selectedRewardProduct: SelectedRewardProductDto;
  isShuffling = false;
  orgDiscountProducts: DiscountProduct[] = [];
  discountProducts: DiscountProduct[] = [];
  googleCustomer: GoogleCustomer;

  //Subscription
  private getActiveDiscountProductSubscription: Subscription;
  private getActiveOffersSubscription: Subscription;

  constructor(
    private myDiscountService: MyDiscountService,
    private apiFactory: APIFactoryEndPoints,
    private localStorage: LocalStorageService,
    private toastService: ToastService,
    private webSocketService: WebSocketService
  ) { }

  ngOnInit(): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.getActiveDiscountProducts();
    this.subscribeToNotifications('my-discount-' + this.googleCustomer.refNo);
  }

  getActiveDiscountProducts() {
    this.getActiveDiscountProductSubscription = this.myDiscountService.getActiveDiscountProducts(this.apiFactory.getActiveDiscountProducts, this.googleCustomer.refNo)
      .subscribe((data: DiscountProduct[]) => {
        if (data) {
          this.orgDiscountProducts = data;
          this.filterCoupons('home');
        }
      });
  }

  filterCoupons(tab: string) {
    this.activeTab = tab;
    this.activeSort = '';
    if (tab === 'home') {
      this.discountProducts = this.orgDiscountProducts.filter(
        discountProduct => discountProduct.status === null || discountProduct.status === 'Generated'
      );
    } else {
      this.discountProducts = this.orgDiscountProducts.filter(discountProduct => discountProduct.status === 'Redeemed');
    }
    this.homeCount = this.orgDiscountProducts.filter(discountProduct => discountProduct.status === null || discountProduct.status === 'Generated').length;
    this.redeemedCount = this.orgDiscountProducts.filter(discountProduct => discountProduct.status === 'Redeemed').length;
  }

  tryMyLuck(product: DiscountProduct) {
    this.selectedRewardType = null;
    this.qrData = '';

    this.getActiveOffersSubscription = this.myDiscountService.getActiveOffers(this.apiFactory.getActiveOffersForDiscountProducts, this.googleCustomer.refNo, product.productCode, product.festivalDiscountSetupCode)
      .subscribe((data: SelectedRewardProductDto) => {
        if (data) {
          this.showLuckModal = true;
          this.isShuffling = true;
          this.selectedRewardProduct = data;
          setTimeout(() => {
            this.wonDiscount = this.selectedRewardProduct.value;
            this.isShuffling = false;
            this.launchCelebration();

          }, 2000); // shuffle effect for 2 seconds
        }
      });
  }

  onRewardTypeChange(type: 'money' | 'product') {
    this.selectedRewardType = type;

    if (this.selectedRewardProduct) {
      const dynamicCode = this.selectedRewardProduct.dynamicCode;
      this.qrData =
        type === 'money'
          ? `Code=${dynamicCode}&Type=Price`
          : `Code=${dynamicCode}&Type=Product`;
    }
  }

  closeModal() {
    this.showLuckModal = false;
    this.selectedRewardType = null;
    this.qrData = '';
    this.getActiveDiscountProducts();
  }
  @ViewChild('confettiCanvas', { static: false }) confettiCanvas!: ElementRef;

  launchCelebration() {
    if (this.confettiCanvas) {
      const myConfetti = confetti.create(this.confettiCanvas.nativeElement, {
        resize: true,
        useWorker: true
      });

      myConfetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 }
      });
    }
  }

  subscribeToNotifications(id: any) {
    let stompClient = this.webSocketService.connect(); // Get the Stomp client
    stompClient.onConnect = (frame) => {
      console.log("Connected: " + frame);
      stompClient.subscribe(`/topic/${id}/notification`, (message) => {
        // alert(message.body);
        this.toastService.showSuccessToast(message.body);
        this.filterCoupons('redeemed');
      });
    };

    stompClient.onStompError = (frame) => {
      console.error("STOMP Error:", frame);
    };

    stompClient.activate(); // Activate the WebSocket connection
  }

  // this.productList = [
  //   { productName: 'Veg Puff', image: 'product/Veg Puff.webp', product_Code: 850, net_Sale_Price: 22 },
  //   { productName: 'Osmania Cookies', image: 'product/Osmania Cookies.webp', product_Code: 819, net_Sale_Price: 40 },
  //   { productName: 'Little Hearts', image: 'product/Little Hearts.webp', product_Code: 828, net_Sale_Price: 60 },
  //   { productName: 'Raagi Crackers', image: 'product/Raagi Crackers.webp', product_Code: 824, net_Sale_Price: 70 },
  // ];
  // rewardOptions: RewardOption[] = [
  //   { amount: 10, productName: 'Veg Puff', productImage: 'product/Veg Puff.webp', productCode: 850, net_Sale_Price: 22 },
  //   { amount: 20, productName: 'Osmania Cookies', productImage: 'product/Osmania Cookies.webp', productCode: 819, net_Sale_Price: 40 },
  //   { amount: 30, productName: 'Little Hearts', productImage: 'product/Little Hearts.webp', productCode: 828, net_Sale_Price: 60 },
  //   { amount: 40, productName: 'Raagi Crackers', productImage: 'product/Raagi Crackers.webp', productCode: 824, net_Sale_Price: 70 },
  // ];

}